import { render } from "./TheLoaiTruDen.vue?vue&type=template&id=3e7ea766"
import script from "./TheLoaiTruDen.vue?vue&type=script&lang=js"
export * from "./TheLoaiTruDen.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__